// const initAuthData = {
//     isAuth : false,
//     user :{}
// };

// const AuthReducer = (state = initAuthData, actions) => {

//     switch(actions.type) {
//         case "SET_LOGIN":
//             return {
//                 ...state,
//                 isAuth: true,
//                 user: actions.payload
//             };
//         case "MAKE_LOGOUT":
//             return {
//                 ...state,
//                 isAuth: false,
//                 user: {}
//             };
//         default:
//             return state;
//     }
// }

// export default AuthReducer;

import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import config from "../../core/config";
import Cookies from 'js-cookie'; // You can keep this if you still want to use cookies for other data

const initialState = {
    token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
    signupData: Cookies.get('signupData') ? JSON.parse(Cookies.get('signupData')) : [],
}

export const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setProfileData(state, action) {
            state.signupData = action.payload;

            Cookies.set('signupData', JSON.stringify(state.signupData)); // Save signupData to localStorage
        },
        logout(state) {
            state.tokenDetails = null;
            state.signupData = [];
            localStorage.removeItem('token'); // Remove tokenDetails from localStorage
            Cookies.remove('signupData'); // Remove signupData from localStorage
        },
        setLoginData(state, action) {
            state.token = action.payload;
            console.log("token : ",action.payload)
            localStorage.setItem('token', JSON.stringify(action.payload)); // Save tokenDetails to localStorage
            localStorage.setItem('token', action.payload); // Save token to localStorage
            // localStorage.setItem('user', JSON.stringify(action.payload.user)); // Save user data to localStorage
        },
        clearDataIfInvalid(state) {
            if (!state.signupData || !state.token) {
                state.signupData = null;
                state.tokenDetails = null;
                Cookies.remove('signupData');
                localStorage.removeItem("token");
            }
        }
    }
});

// Thunks for logout functionality
export const makeLogout = () => async (dispatch) => {
    try {
        const token = localStorage.getItem('tokenDetails');
        const response = await axios.post(`${config.rootUrl}/${config.uris.LOGOUT_URI}`, { token });
        dispatch(logout()); // Call the logout reducer
    } catch (error) {
        console.error('Logout Error:', error);
    }
};

export const { setProfileData, setLoginData, logout, clearDataIfInvalid } = authSlice.actions;
export default authSlice.reducer;
